import React, {useContext, useEffect, useRef, useState} from 'react';
import { IonApp, IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonItem, IonList, IonSplitPane, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonSlides } from '@ionic/react';
import { IonTabs, IonTabBar, IonTabButton, IonText, IonLabel, IonFooter, IonSlide, IonImg, IonRouterOutlet } from '@ionic/react';

import '../../css/layout.css';

import { ShowProductPicsModal } from './Modal_ShowProductPics_Public'
import { Modal_Checkout_Retail } from './Modal_Checkout_Retail';

import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';

import { Preferences } from '@capacitor/preferences'

function addStorage_cart(event) {

    //alert(event);

    Preferences.set({
        key: 'cartList',
        value: JSON.stringify(event),
        //value: [event[0], event[1], event[2], event[3],  event[4]].toString(),

    })
}



 export function ViewProductDetailDataModal_Public (props) {



    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [companyID, setCompanyID ] = useState(props.data.companyId);

    let [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    let [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [employeeID, setEmployeeID] = useState(authenticatedMerchent_context.employeeID);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL] = useState(authenticatedMerchent_context.baseURL);
    
    let [productID, setProductID] = useState(null);
    let [productName, setProductName] = useState(null);
    let [productPrice, setProductPrice] = useState(null);
    let [productQuantity, setProductQuantity] = useState(1);
    let [qtyAvailable, setQtyAvailable] = useState(null);

    let [productPicsModal, setProductPicsModal] = useState(false);
    let [viewProductDetailsData, setViewProductDetailsData] = useState([]);

    let [openCheckoutModal, setOpenCheckoutModal] = useState(false);

    const [cartList, setCartList] = useState(authenticatedMerchent_context.cartList);



function getProductDetailData() {

    const requestOptions = {
        method: 'POST',
        //credentials: 'include',
        headers: {
            'Accept': 'text/html, application/json',
            'content-type': 'application/json',
            //'cookie': 'cookie',
        },
        body: JSON.stringify({
            Tracker: '74308_retail_public',
            xCompanyID_public: props.data.companyId,
            xProductID: props.data.productID,
            sessionID: sessionID,
        }),
    }

    //alert(props.data.companyId);
    //alert(props.data.productID);

    
    fetch(baseURL+'ghanaverified/', requestOptions)
    .then(res => res.text())
    .then(res => {

        let rows = res.toString().split('~~~');

        for (let rownum = 0; rownum < rows.length - 1; ++rownum)
        {
            let cols = rows[rownum].split('|');

            setProductID(cols[0]);
            setProductName(cols[2]);
            setProductPrice(parseFloat(cols[9]).toFixed(2));
            setQtyAvailable(cols[15]);

            setViewProductDetailsData((prevViewProductDetailsData) => {
                return prevViewProductDetailsData.concat({
                    productID: cols[0],
                    productType: cols[1],
                    productName: cols[2],
                    productDescription: cols[3],
                    productPartNum: cols[4],
                    productPhoneNumber: cols[5],
                    productAddress: cols[6],
                    productCity: cols[7],
                    productCountry: cols[8],
                    productSalePrice: parseFloat(cols[9]).toFixed(2),
                    productPic1: cols[10],
                    productPic2: cols[11],
                    productPic3: cols[12],
                    productPic4: cols[13],
                    attachment: cols[14],
                    qtyAvailable: cols[15],
                    publicePrice: cols[16],

                })
            });

        }
        
    })

}



function addToCartHandler(event) 
{

    //alert(event);

    let cartItems = {
        id: event[1],
        name: event[2],
        price: event[3],
        quantity: event[4],
        };

    // alert(cartItems);
    // alert(JSON.stringify(cartItems));

    // alert(cartList);

    setCartList((prevCartList) => {
        const updatedCartList = [...prevCartList, cartItems]; // Keep old items + new one

        // Store the updated list in local storage
        addStorage_cart(updatedCartList);

        return updatedCartList; // Update state
    });

    authenticatedMerchent_context.changeCartList((prevCartList) => {
        return [...prevCartList, cartItems];
    });

    // setCartList((viewCartList) => {
    //     return viewCartList.concat(JSON.stringify(cartItems))
    // });

    // authenticatedMerchent_context.changeCartList((viewCartList) => {
    //     return viewCartList.concat(JSON.stringify(cartItems))
    // });

    // addStorage_cart(cartList);

    alert("ITEM ADDED TO CART");

    // alert(cartList);
    // alert(JSON.stringify(cartList));

}

function setProductQtyHandler(event)
{
    if(event == "increase")
    {
        let newQuantity = productQuantity + 1;

        setProductQuantity(newQuantity);
    }
    else if(event == "decrease")
    {
        let newQuantity = productQuantity - 1;

        setProductQuantity(newQuantity);  
    }
}

function closeModalHandler() {

    setOpenCheckoutModal(false);
    props.closeModal(false);
}

function checkoutHandler()
{
    // alert('In Checkout Handler');
    // alert(cartList);
    // alert(cartList.length);

    if(cartList.length == 0)
    {
        alert('CART IS EMPTY');
    }
    else
    {
        setOpenCheckoutModal(true);
    }
}

useEffect(() =>  {

    //alert("In produt detals modal");
    //alert(props.data.productID);

        
    getProductDetailData(); 

}, [])

            return(

                <React.Fragment>
                {props.openModal == true ?
                (
            <IonModal id='showProductDetails' isOpen={ props.openModal}>
                    <IonHeader className='grid_header' style={{ color: "black" }} fullscreen={true}>
                        <IonToolbar>
                            <IonGrid >
                                <IonRow>
                                    <IonCol>
                                        <IonText style={{ fontWeight: 'bold'}}> Product Name </IonText>
                                    </IonCol>
                                    <IonCol >                                    
                                        <IonText style={{ fontWeight: 'bold'}}> In-Stock </IonText>
                                    </IonCol>
                                </IonRow>
                                <IonRow >
                                    <IonCol>
                                        <IonText> {productName}</IonText>
                                    </IonCol>
                                    <IonCol >                                    
                                        <IonText>{qtyAvailable}</IonText>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </IonToolbar>
                    </IonHeader>
                    <IonContent className='grid_content'>
                        {viewProductDetailsData.map((detailData) =>   {
                            return (
                            <IonGrid>
                                <IonRow>
                                    <IonCol>
                                        <IonText style={{ fontWeight: 'bold', fontSize: '1.7em' }}>{"GHS "+detailData.publicePrice}</IonText>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol size='12'>
                                        <ShowProductPicsModal openModal={ productPicsModal } closeModal={() => setProductPicsModal(false)} data={{
                                        productPic1: detailData.productPic1, 
                                        productPic2: detailData.productPic2, 
                                        productPic3: detailData.productPic3, 
                                        productPic4: detailData.productPic4, 
                                        productID: detailData.productID, 
                                        productPublicPrice: detailData.publicePrice,
                                        companySchema: props.data.companySchema,
                                        }}></ShowProductPicsModal>
                                        <IonButton onClick={() => setProductPicsModal(true)}> View </IonButton>
                                    </IonCol>
                                </IonRow>
                                <IonRow >
                                    <IonCol size='12'>
                                        <IonText style={{ fontWeight: 'bold' }}>Specifications:  </IonText>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol size='12'>
                                        {/*<IonText>{detailData.productDescription}</IonText>*/}
                                        <textarea cols="40" rows="15" value={detailData.productDescription}></textarea>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol size='4'>
                                        <IonText style={{ fontWeight: 'bold' }}>QTY: </IonText>
                                    </IonCol>
                                    <IonCol size='4'>
                                        <IonText style={{ fontWeight: 'bold', fontSize: '2em' }}>{productQuantity}</IonText>
                                    </IonCol>
                                    
                                    <IonCol size='2'>
                                        <IonButton onClick={() => setProductQtyHandler("increase")}> UP </IonButton>
                                    </IonCol>
                                    <IonCol size='2'>
                                        <IonButton onClick={() => setProductQtyHandler("decrease")}> DOWN </IonButton>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol >
                                    <IonButton onClick={() => addToCartHandler([true, detailData.productID, detailData.productName, detailData.publicePrice, productQuantity])}> Add To Cart </IonButton>
                                    <IonButton onClick={() => checkoutHandler([true, detailData.productID])}> Checkout </IonButton>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                                    )
                                }
                            )}
                        </IonContent>
                        <IonButton className='button_closeModal_center' onClick={() => closeModalHandler()}>Back </IonButton>
                    </IonModal>) : null}



                {openCheckoutModal == true &&   <Modal_Checkout_Retail openModal={ openCheckoutModal } closeModal={() => closeModalHandler()}  data={{
                        status: props.data.status,
                        companyId: props.data.companyId,
                        companyPhoneNumber: props.data.companyPhoneNumber,
                        mtnCompanyPhoneNumber: props.data.mtnCompanyPhoneNumber,
                        cartList: cartList,
                        }}></Modal_Checkout_Retail> }

    </React.Fragment>
            )
}   



export default ViewProductDetailDataModal_Public;